import { render } from "./DrinkMenu.vue?vue&type=template&id=1df893fc&scoped=true"
import script from "./DrinkMenu.vue?vue&type=script&lang=js"
export * from "./DrinkMenu.vue?vue&type=script&lang=js"

import "./DrinkMenu.vue?vue&type=style&index=0&id=1df893fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df893fc"]])

export default __exports__